var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#77928B",
    fillRule: "evenodd",
    d: "M10.111 9.6c2.091 0 3.797 1.698 3.885 3.826L14 13.6v1.6c0 .442-.348.8-.778.8-.399 0-.727-.309-.772-.707l-.006-.093v-1.6c0-1.278-.97-2.323-2.196-2.396l-.137-.004H3.89c-1.243 0-2.259 1-2.33 2.259l-.003.141v1.6c0 .442-.349.8-.778.8-.4 0-.728-.309-.773-.707L0 15.2v-1.6c0-2.151 1.65-3.905 3.72-3.996L3.89 9.6h6.222zM7 0c2.148 0 3.889 1.79 3.889 4S9.148 8 7 8C4.852 8 3.111 6.21 3.111 4S4.852 0 7 0zm0 1.6C5.711 1.6 4.667 2.675 4.667 4S5.71 6.4 7 6.4c1.289 0 2.333-1.075 2.333-2.4S8.29 1.6 7 1.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.1b03ba3c03ff5808e20a44a428cf2891.svg";
export { ForwardRef as ReactComponent };